import validator from 'validator';
import { trimLeft } from 'lodash';
import Regionalization from 'services/regionalization';

function validateEmail (data, errors) {
  const { email } = data;

  if (!email) {
    errors.email = 'Required';
  } else if (!validator.isEmail(email)) {
    errors.email = 'Email format does not appear to be valid';
  }
}

function validatePassword (data, errors, key = 'password') {
  const password = data[key];

  if (!password) {
    errors[key] = 'Required';
  } else if (password.length < 6) {
    errors[key] = 'Password must be minimum 6 characters in length';
  }
}

export function validateLogin (data) {
  const errors = {};

  validateEmail(data, errors);
  validatePassword(data, errors);

  return errors;
}

export function validateChangeEmail (data) {
  const errors = {};

  validateEmail(data, errors);
  validatePassword(data, errors);

  return errors;
}

export function validateChangePassword (data) {
  const errors = {};

  validatePassword(data, errors, 'oldPassword');
  validatePassword(data, errors, 'newPassword');

  return errors;
}

function validateProfileRegistration (data, errors) {
  const {
    firstName,
    lastName
  } = data;

  if (!firstName) {
    errors.firstName = 'Required';
  } else if (firstName.length > 80) {
    errors.firstName = 'Please use a shorter name';
  }

  if (!lastName) {
    errors.lastName = 'Required';
  } else if (lastName.length > 80) {
    errors.lastName = 'Please use a shorter name';
  }
}

function validateSchool(data, errors) {
  const {
    country,
    cityOrMunicipality,
    stateOrProvince,
    school
  } = data;

  if (!cityOrMunicipality) {
    errors.cityOrMunicipality = 'Required';
  } else if (cityOrMunicipality.length > 80) {
    errors.cityOrMunicipality = 'Please use a shorter name';
  }

  if (!country) {
    errors.country = 'Required';
  }

  if (!stateOrProvince || !Regionalization.isValidStateOrProvinces(country, stateOrProvince)) {
    errors.stateOrProvince = 'Required';
  }

  if (!school) {
    errors.school = 'Required';
  } else if (school.length > 80) {
    errors.school = 'Please use a shorter name';
  }
}

export function validateRegistration (data) {
  const errors = {};
  const { termsAccepted } = data;

  validateProfileRegistration(data, errors);
  validateEmail(data, errors);
  validatePassword(data, errors);

  if (!termsAccepted) {
    errors.termsAccepted = 'Required';
  }

  return errors;
}

export function validateCompleteRegistration (data) {
  const errors = {};

  validateSchool(data, errors);

  return errors;
}

export function validateEditProfile (data) {
  const errors = {};

  validateProfileRegistration(data, errors);
  validateSchool(data, errors);

  return errors;
}

export function validateForgotPassword (data) {
  const errors = {};

  validateEmail(data, errors);

  return errors;
}

export const normalizeRegisterForm = {
  firstName: value => value && trimLeft(value),
  lastName: value => value && trimLeft(value),
  phone: value => value && trimLeft(value),
  cityOrMunicipality: value => value && trimLeft(value),
  school: value => value && trimLeft(value),
  marketingOptIn: value => !!value
};



// WEBPACK FOOTER //
// ./src/utils/validateNormalize.js